import { render, staticRenderFns } from "./webinars.vue?vue&type=template&id=6215c33e&scoped=true"
import script from "./webinars.vue?vue&type=script&lang=js"
export * from "./webinars.vue?vue&type=script&lang=js"
import style0 from "./webinars.vue?vue&type=style&index=0&id=6215c33e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6215c33e",
  null
  
)

export default component.exports